import { filter, map, Observable } from 'rxjs';
import { inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isNotNil, Nillable } from '@web/utils';
import { RouteParam } from '../enums/route-param';

export function activatedRouteParamAsString(
  param: RouteParam,
): Observable<string>;
export function activatedRouteParamAsString(
  param: RouteParam,
  options?: { nillable: true },
): Observable<Nillable<string>>;
export function activatedRouteParamAsString(
  param: RouteParam,
  options?: { nillable: boolean },
): Observable<Nillable<string>> {
  const activatedRoute = inject(ActivatedRoute);

  const findParamInRouteHierarchy = (route: ActivatedRoute): string | null => {
    let currentRoute: ActivatedRoute | null = route;

    while (currentRoute) {
      const paramValue = currentRoute.snapshot.paramMap.get(param);

      if (paramValue !== null) {
        return paramValue;
      }

      currentRoute = currentRoute.parent;
    }

    return null;
  };

  if (options?.nillable) {
    return activatedRoute.paramMap.pipe(
      map(() => findParamInRouteHierarchy(activatedRoute)),
    );
  }

  return activatedRoute.paramMap.pipe(
    map(() => findParamInRouteHierarchy(activatedRoute)),
    filter(isNotNil),
  );
}
